// Dependencias generales
import React from "react";
import { useEffect } from 'react';


import SpaSVG from '../../img/spa.svg'; //Esto lo meto para que no salte el warning

import EngSVG from '../../img/eng.svg';
import CatSVG from '../../img/cat.svg';
import GalSVG from '../../img/gal.svg';
import EusSVG from '../../img/eus.svg';


var generalCommonJS = require("../../js/generalCommon.js")

function incluirFooter(){    
  var rootAuthenticatorDiv = document.getElementById("root").firstChild  

  if(document.getElementById("footerLogin") === null){ 

    var componenteFooter = document.createElement('footer');     
    componenteFooter.setAttribute("id", "footerLogin");
    componenteFooter.innerHTML = '<p><a id="fevergy-logo" href="https://fevergy.com"><span>Fevergy</span></a></p>'    
    
    if(rootAuthenticatorDiv !== null){
      rootAuthenticatorDiv.appendChild(componenteFooter)
    }

  }
}



// Función del router
const FooterLogin = () => {
  
  useEffect(() => {    
    incluirFooter();   
  }, []);

  return (          
    <>  

    <button id="botonPrivacidadLogin" className="amplify-button amplify-field-group__control amplify-button--link amplify-button--small privacy-button" onClick={() => generalCommonJS.mostrarPrivacidad()}>Privacidad</button>
    
    {/*
    <footer-language style={{display: "none"}}>
      <li className="language-trigger">
          <span className="language"><img src={SpaSVG} alt="Idioma"/>Español</span>
          <ul className="language-list">
            <li><span className="language"><img src={SpaSVG} alt="Español"/>Español</span></li>
            <li><span className="language"><img src={EngSVG} alt="English"/>English</span></li>
            <li><span className="language"><img src={CatSVG} alt="Català"/>Català</span></li><li>
            <span className="language"><img src={GalSVG} alt="Galego"/>Galego</span></li><li>
            <span className="language"><img src={EusSVG} alt="Euskera"/>Euskera</span></li>
          </ul>
      </li>
    </footer-language>
    */}

    </>
  )
}

export default FooterLogin